var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderedList = function SvgOrderedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98A2B3",
    d: "M6.125 18.375h1.75v.438H7v.875h.875v.437h-1.75V21H8.75v-3.5H6.125zM7 10.5h.875V7h-1.75v.875H7zm-.875 2.625H7.7l-1.575 1.838v.787H8.75v-.875H7.175l1.575-1.838v-.787H6.125zm4.375-5.25v1.75h12.25v-1.75zm0 12.25h12.25v-1.75H10.5zm0-5.25h12.25v-1.75H10.5z"
  })));
};
export default SvgOrderedList;